import { initReact } from '../../../Shared/js/vendor/react';
import * as WidgetComponents from './components';

function initWidgetComponents() {
    initReact();
    window['WidgetComponents'] = window['WidgetComponents'] || WidgetComponents;
}

initWidgetComponents();
